module.exports = __webpack_public_path__ + "static/media/savora.20a84764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/savora.png
// module id = 972
// module chunks = 0